export const ClockoutAttestationAPI = new function () {
    const self = this;
    const _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.getBaseAPI("EmployeeAttestationServer"));

    self.ATTESTATION_SETTINGS_TYPES = {
        CLOCK_OUT: 'CLOCK_OUT',
    };

    self.ATTESTATION_TEMPLATES_TYPES = {
        CLOCK_OUT: 'CLOCK_OUT',
    };

    /**
     * Check if level activation is enabled for clockout attestation
     * @param {number} brandId - The brand ID
     * @param {string} type - The type of setting (clockout-attestation)
     * @returns {Promise} Promise that resolves to level activation data
     */
    self.isLevelActivated = async function (brandId, type) {
        if (!brandId) {
            throw "Brand id is required";
        }

        if (!type) {
            throw "Type is required";
        }

        const res = await _protected.request(`brands/${brandId}/settings/${type}/level_activation`, 'GET');

        if (res.data?.data && res.status === 200) {
            return res.data.data;
        }

        throw res;
    };

    self.getCustomAttestations = async (brandId, settingsType, attestationType, clockId) => {
        if (!brandId) {
            throw "Brand id is required";
        }

        if (!settingsType || !attestationType || !clockId) {
            throw "Types and clockId are required";
        }

        const res = await _protected.request(`brands/${brandId}/settings/${settingsType}/attestation_templates/${attestationType}/owner_entity/${clockId}`, 'GET');

        if (res.data?.data && res.status === 200) {
            return res.data.data?.owner_entity?.attestations || [];
        }

        throw res;

    }
}; 